module.exports = __webpack_public_path__ + "static/media/XRP-BUSD.8ee8081a.png";